import { getReq } from "./instance";

export const getSideEffect = async (sideEffectId: string, params = {}) => {
  return getReq(`/SideEffect/${sideEffectId}`, params);
};
